export const userAdmin3 = {
  sidebar: {
    logo: "Bespire",
    providerName: "Szépségstúdió Bella",
    menu: {
      dashboard: "Áttekintés",
      booking: "Időpontfoglalás",
      services: "Szolgáltatások",
      workshops: "Workshopok",
      digitalContent: "Digitális tartalmak",
      memberships: "Bérleteim",
      messages: "Üzeneteim",
      loyalty: "Hűségjutalmak",
      progress: "Fejlődésem",
      settings: "Beállítások",
    },
  },
  header: {
    notifications: "Értesítések",
    profile: "Profil",
    pages: {
      dashboard: {
        title: "Áttekintés",
        description: "Foglalásaid, bérleteid és közelgő eseményeid",
      },
      booking: {
        title: "Időpontfoglalás",
        description: "Foglalj időpontot a szolgáltatóhoz",
      },
      services: {
        title: "Szolgáltatások",
        description: "Elérhető szolgáltatások böngészése és vásárlás",
      },
      workshops: {
        title: "Workshopok",
        description: "Közelgő workshopok és képzések",
      },
      digitalContent: {
        title: "Digitális tartalmak",
        description: "E-bookok, videókurzusok és egyéb tartalmak",
      },
      memberships: {
        title: "Bérleteim",
        description: "Aktív bérleteid és tagságaid kezelése",
      },
      messages: {
        title: "Üzeneteim",
        description: "Kommunikáció a szolgáltatóval",
      },
      loyalty: {
        title: "Hűségjutalmak",
        description: "Hűségpontjaid és jutalmaid",
      },
      settings: {
        title: "Beállítások",
        description: "Profil és értesítési beállítások",
      },
      progress: {
        title: "Fejlődésem",
        description: "Kövesd nyomon a fejlődésed és érj el új célokat",
      },
    },
  },
  dashboard: {
    welcome: "Üdvözlünk vissza!",
    welcomeDescription: "Itt van egy áttekintés az aktuális tevékenységeidről",
    upcomingBookings: "Közelgő időpontok",
    noBookings: "Nincs közelgő időpontod",
    activeMemberships: "Aktív bérletek",
    noMemberships: "Nincs aktív bérleted",
    recentPurchases: "Utolsó vásárlások",
    noPurchases: "Nincs korábbi vásárlásod",
    loyaltyPoints: "Hűségpontok",
    viewAll: "Összes megtekintése",
    bookNow: "Foglalás most",
    points: "pont",
    validUntil: "Érvényes eddig",
    nextEvent: "Következő esemény",
  },
  booking: {
    title: "Időpontfoglalás",
    selectService: "Válassz szolgáltatást",
    selectDate: "Válassz dátumot",
    selectTime: "Válassz időpontot",
    availableSlots: "Elérhető időpontok",
    noSlots: "Nincs elérhető időpont erre a napra",
    bookButton: "Foglalás",
    confirmBooking: "Foglalás megerősítése",
    bookingSuccess: "Sikeres foglalás!",
    bookingSuccessDescription: "Az időpontod sikeresen lefoglalva.",
    duration: "Időtartam",
    price: "Ár",
    minutes: "perc",
    myBookings: "Foglalásaim",
    upcoming: "Közelgő",
    past: "Korábbi",
    cancel: "Lemondás",
    reschedule: "Átfoglalás",
    status: {
      confirmed: "Megerősítve",
      pending: "Függőben",
      cancelled: "Lemondva",
      completed: "Teljesítve",
    },
  },
  services: {
    title: "Szolgáltatások",
    categories: "Kategóriák",
    all: "Összes",
    popular: "Népszerű",
    new: "Új",
    details: "Részletek",
    bookService: "Szolgáltatás foglalása",
    buyNow: "Vásárlás most",
    addToCart: "Kosárba",
    from: "tól",
    reviews: "értékelés",
    duration: "Időtartam",
    included: "Tartalmazza",
  },
  workshops: {
    title: "Workshopok",
    upcoming: "Közelgő workshopok",
    past: "Korábbi workshopok",
    registered: "Jelentkeztem",
    spotsLeft: "szabad hely",
    full: "Betelt",
    register: "Jelentkezés",
    unregister: "Lemondás",
    date: "Dátum",
    location: "Helyszín",
    online: "Online",
    inPerson: "Személyes",
    participants: "résztvevő",
    maxParticipants: "max. résztvevő",
    price: "Ár",
    free: "Ingyenes",
    description: "Leírás",
    materials: "Anyagok",
  },
  digitalContent: {
    title: "Digitális tartalmak",
    purchased: "Megvásárolt",
    available: "Elérhető",
    download: "Letöltés",
    preview: "Előnézet",
    buy: "Megvásárlás",
    categories: {
      ebook: "E-book",
      video: "Videókurzus",
      audio: "Hanganyag",
      template: "Sablon",
      guide: "Útmutató",
    },
    format: "Formátum",
    size: "Méret",
    purchaseDate: "Vásárlás dátuma",
  },
  memberships: {
    title: "Bérleteim",
    active: "Aktív",
    expired: "Lejárt",
    renew: "Megújítás",
    cancel: "Lemondás",
    upgrade: "Frissítés",
    validFrom: "Érvényes",
    validUntil: "Lejárat",
    remainingUses: "Hátralévő alkalmak",
    unlimited: "Korlátlan",
    autoRenewal: "Automatikus megújítás",
    history: "Bérlet történet",
    benefits: "Előnyök",
    currentPlan: "Jelenlegi csomag",
  },
  messages: {
    title: "Üzeneteim",
    newMessage: "Új üzenet",
    sendMessage: "Küldés",
    placeholder: "Írd ide az üzeneted...",
    noMessages: "Nincs üzeneted",
    sent: "Elküldve",
    received: "Beérkezett",
    read: "Olvasott",
    unread: "Olvasatlan",
    attachFile: "Fájl csatolása",
    responseTime: "Átlagos válaszidő",
    hours: "óra",
  },
  loyalty: {
    title: "Hűségjutalmak",
    currentPoints: "Jelenlegi pontjaid",
    totalEarned: "Összesen szerzett",
    level: "Szint",
    nextLevel: "Következő szint",
    pointsToNext: "pont a következő szintig",
    rewards: "Beváltható jutalmak",
    history: "Pont történet",
    earned: "Szerzett",
    redeemed: "Beváltott",
    redeem: "Beváltás",
    levels: {
      bronze: "Bronz",
      silver: "Ezüst",
      gold: "Arany",
      platinum: "Platina",
    },
  },
  settings: {
    title: "Beállítások",
    profile: {
      title: "Profil beállítások",
      name: "Név",
      email: "E-mail",
      phone: "Telefonszám",
      save: "Mentés",
      avatar: "Profilkép",
      changeAvatar: "Kép módosítása",
    },
    notifications: {
      title: "Értesítési beállítások",
      email: "E-mail értesítések",
      push: "Push értesítések",
      sms: "SMS értesítések",
      bookingReminder: "Foglalási emlékeztető",
      workshopReminder: "Workshop emlékeztető",
      promotions: "Promóciók és ajánlatok",
      newsletter: "Hírlevél",
    },
    privacy: {
      title: "Adatvédelem",
      deleteAccount: "Fiók törlése",
      exportData: "Adatok exportálása",
    },
  },
  progress: {
    title: "Fejlődésem",
    description: "Kövesd nyomon a fejlődésed és érj el új célokat",
    stats: {
      totalSessions: "Összes alkalom",
      activeGoals: "Aktív célok",
      currentStreak: "Jelenlegi sorozat",
      completionRate: "Teljesítési arány",
      days: "nap",
      sessions: "alkalom",
    },
    goals: {
      title: "Céljaid",
      addGoal: "Új cél hozzáadása",
      progress: "Haladás",
      completed: "Teljesítve",
      inProgress: "Folyamatban",
      notStarted: "Még nem kezdte el",
      markComplete: "Késznek jelölés",
      deleteGoal: "Cél törlése",
      goalName: "Cél neve",
      targetValue: "Célérték",
      currentValue: "Jelenlegi érték",
      deadline: "Határidő",
      category: "Kategória",
      categories: {
        fitness: "Edzés",
        coaching: "Coaching",
        beauty: "Szépségápolás",
        education: "Tanulás",
        wellness: "Wellness",
        other: "Egyéb",
      },
    },
    metrics: {
      title: "Mérőszámok",
      weight: "Testsúly",
      performance: "Teljesítmény",
      skinHealth: "Bőr állapota",
      energy: "Energia szint",
      satisfaction: "Elégedettség",
      unit: "egység",
      trend: "Trend",
      improving: "Javuló",
      declining: "Csökkenő",
      stable: "Stabil",
    },
    milestones: {
      title: "Mérföldkövek",
      achieved: "Elérve",
      locked: "Zárolva",
      progress: "Haladás",
    },
    timeline: {
      title: "Tevékenységek",
      today: "Ma",
      thisWeek: "Ezen a héten",
      thisMonth: "Ebben a hónapban",
      earlier: "Korábban",
      types: {
        booking: "Foglalás",
        purchase: "Vásárlás",
        workshop: "Workshop",
        goalCompleted: "Cél teljesítve",
        milestoneReached: "Mérföldkő elérve",
        sessionCompleted: "Alkalom teljesítve",
      },
    },
  },
  common: {
    loading: "Betöltés...",
    error: "Hiba történt",
    retry: "Újrapróbálkozás",
    save: "Mentés",
    cancel: "Mégse",
    confirm: "Megerősítés",
    delete: "Törlés",
    edit: "Szerkesztés",
    back: "Vissza",
    next: "Tovább",
    currency: "Ft",
    noData: "Nincs adat",
  },
};
